import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/progress/index.js
// module id = 388
// module chunks = 14